import { Link } from "react-router-dom";
import { Facebook, Instagram, Linkedin, MapPin, Phone, Mail } from "lucide-react";
import { BRAND, NAV_LINKS } from "@/data/urban";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-black text-white pt-16 pb-24 sm:pb-8">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="font-heading text-xl font-extrabold tracking-tight">URBAN RENOVATIONS</div>
            <div className="text-[9px] uppercase tracking-[0.24em] text-white/60 mt-1">Interiors · Renovation · Design</div>
            <p className="mt-5 text-sm text-white/70 max-w-md leading-relaxed">{BRAND.tagline}</p>
            <p className="mt-3 text-xs text-white/50">A service brand of <span className="text-white font-semibold">{BRAND.company}</span> · Working Since {BRAND.since}</p>
            <div className="mt-6 flex items-center gap-2">
              {[[Facebook, BRAND.social.facebook], [Instagram, BRAND.social.instagram], [Linkedin, BRAND.social.linkedin]].map(([Ic, href], i) => (
                <a key={i} href={href} target="_blank" rel="noopener noreferrer" className="h-10 w-10 rounded-md border border-white/15 flex items-center justify-center hover:bg-white hover:text-black transition-colors" aria-label="Social"><Ic className="h-4 w-4" /></a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="font-heading font-bold mb-4 uppercase tracking-wider text-sm">Quick Links</div>
            <ul className="space-y-2.5 text-sm text-white/70">
              {NAV_LINKS.map((l) => <li key={l.key}><Link to={l.href} className="hover:text-white transition-colors">{l.label}</Link></li>)}
              <li><Link to="/blog" className="hover:text-white transition-colors">Blog</Link></li>
              <li><Link to="/faq" className="hover:text-white transition-colors">FAQ</Link></li>
              <li><Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-4">
            <div className="font-heading font-bold mb-4 uppercase tracking-wider text-sm">Get in touch</div>
            <ul className="space-y-3 text-sm text-white/70">
              <li className="flex items-start gap-2.5"><MapPin className="h-4 w-4 mt-0.5" /> {BRAND.address}</li>
              <li className="flex items-center gap-2.5"><Phone className="h-4 w-4" /> <a href={`tel:${BRAND.phoneRaw}`} className="hover:text-white">{BRAND.phone}</a></li>
              <li className="flex items-center gap-2.5"><Mail className="h-4 w-4" /> {BRAND.email}</li>
              <li className="text-white/50 text-xs mt-4">{BRAND.domain}</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <div>© {year} Urban Renovations · A service brand of Urban Painter. All Rights Reserved.</div>
          <div className="flex items-center gap-5">
            <Link to="/privacy" className="hover:text-white">Privacy</Link>
            <Link to="/terms" className="hover:text-white">Terms</Link>
            <Link to="/contact" className="hover:text-white">Sitemap</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
